import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Project, ProjectType } from "../../models/Project";
import { formatCurrency, calculateEstimatedBudget } from "./ProjectListTable.utils";

interface ProjectBudgetDisplayProps {
	project: Project;
}

const ProjectBudgetDisplay: React.FC<ProjectBudgetDisplayProps> = ({ project }) => {
	const { t } = useTranslation();

	if (project.type === ProjectType.FixedPrice && project.budget) {
		return <>{formatCurrency(project.budget)}</>;
	}

	if (project.type === ProjectType.TimeAndMaterial) {
		const estimatedBudget = calculateEstimatedBudget(project);
		if (estimatedBudget) {
			return (
				<Box>
					<Typography variant="body2" component="span">
						{formatCurrency(estimatedBudget)}
					</Typography>
					<Typography variant="caption" color="text.secondary" display="block">
						{t("project.estimatedBudget")}
					</Typography>
				</Box>
			);
		}
	}

	return <>-</>;
};

export default ProjectBudgetDisplay;